import { createSelector } from "reselect";

// Api
import { createGetPayload } from "src/api/assessment_summaries/payload_generators";
import {
  selectedLocationIdsSelector,
  answersFilterSelector,
  evaluationListPURSSectionSelector
} from "src/selectors/section_selectors/evaluation_list/evaluation_list_purs_selector";

//UI Processors
import SingleValueReduxUtil from "src/ui_processors/single_value";

const pursEvaluationPageLimitSelector = SingleValueReduxUtil.createSelectors(
  "pursEvaluationPageLimit",
  evaluationListPURSSectionSelector
);

export function createFirstPagePayloadSelector() {
  return createSelector(
    pursEvaluationPageLimitSelector.fieldSelector,
    selectedLocationIdsSelector,
    answersFilterSelector,
    (pageLimit, selectedLocationIds, answers) => {
      if (!selectedLocationIds.length) return {};
      return createGetPayload({
        pageLimit,
        answers,
        patient_state: "admitted,new",
        selectedLocationIds,
        pageNumber: 0,
        sortEnabled: "created_at"
      });
    }
  );
}
